import React, { useContext, useEffect, useState } from "react";

import { Col, Row } from "react-bootstrap";
import PsContext from "../../context";
import Announcements from "./announcements";
import HomeSlider from "./homeSlider";
// import Slider from "./sliderstatic/slider"
// import Slider from 'react-slick';

import { SuperSEO } from "react-super-seo";
import { _HOME_PAGE_SETTINGS } from "../../models/fieldSettings";
import { lowerCase } from "../../utils";
import CampusTourVideo from "./campusTourVideo";
import WelcomeBanner from "./welcomeBanner";
import PrincipalMessage from "./principalMessage";
import Thirukural from "../thirukural";
import HomeAboutUsPage from "./homeAboutUsPage";
import HomeOurInstitutions from "./homeOurInstitutions";
import AlumniList from "./alumniList";
import HomeCustomPage from "./homeCustomPage";
import TestimonialsList from "./testimonialsList";
import SliderText from "../defaultLayout/header/sliderText";
import HomeMenus from "./homeMenus";
import OurGallery from "./ourGallery";
import HomeScrollEvent from "./HomeScrollEvent";

const HomePage = (props) => {
  const context = useContext(PsContext);
  const [homePageSettings, setHomePageSettings] = useState([]);

  useEffect(() => {
    _HOME_PAGE_SETTINGS().then((res) => {
      if (res.status == "1") {
        setHomePageSettings(res.data);
      } else {
        console.log("Error on loading home page settings..");
      }
    });
  }, []);

  const checkComponentActive = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    return m && m.show_on_site == "1" ? true : false;
  };

  const componentContent = (compId) => {
    let m = homePageSettings.find(
      (item) => lowerCase(item.component_id) == lowerCase(compId)
    );
    if (m && m.show_on_site == "1") {
      if (m && m.component_filter) {
        let jv = m.component_filter;
        if (jv && jv.length > 3) {
          let x = JSON.parse(jv.trim());
          return x;
        }
      }
    }
    return [];
  };

  return (
    <div>
      <SuperSEO
        title={context.settingValue("billheader_name")}
        description={context.settingValue("billheader_name")}
        lang="en"
      />
      {homePageSettings && (
        <>
          {/* Slider Text */}
          {checkComponentActive("home_horizontal_scroll_news") && (
            <SliderText
              dataSource={componentContent("home_horizontal_scroll_news")}
            />
          )}
          {/* Slider And Announcement */}
          {checkComponentActive("home_slider_wide_announcement") && (
            <Row
              style={{
                background:
                  "linear-gradient(45deg, rgb(220 200 255) 0%, rgb(246 240 255) 100%)",
              }}
            >
              <Col lg={9} md={12} sm={12}>
                <HomeSlider
                  dataSource={componentContent("home_slider_wide_announcement")}
                />
              </Col>
              <Col lg={3} md={12} sm={12}>
                <Announcements />
              </Col>
            </Row>
          )}
          {/* Principal Page */}
          {checkComponentActive("home_principal_message") && (
            <HomeAboutUsPage
              dataSource={componentContent("home_principal_message")}
            />
          )}
          {/* About Page */}
          {checkComponentActive("home_about_us") && (
            <HomeAboutUsPage dataSource={componentContent("home_about_us")} />
          )}
          {/* Vision & Mission Page */}
          {checkComponentActive("home_vision_mission") && (
            <HomeAboutUsPage
              dataSource={componentContent("home_vision_mission")}
            />
          )}
          {/* Menus Section */}
          {checkComponentActive("home_news_menus") && (
            <HomeMenus dataSource={componentContent("home_news_menus")} />
          )}
          {/* Thirukural */}
          {checkComponentActive("thirukural") && (
            <Thirukural dataSource={componentContent("thirukural")} />
          )}
          {/* Home Page Count */}
          {checkComponentActive("home_page_count") && (
            <HomeAboutUsPage dataSource={componentContent("home_page_count")} />
          )}
          {/* Event Section */}
          {checkComponentActive("recent_events") && (
            <HomeScrollEvent dataSource={componentContent("recent_events")} />
          )}
          {/* AlumniList */}
          {checkComponentActive("home_our_alumni") && (
            <AlumniList dataSource={componentContent("home_our_alumni")} />
          )}
          {/* Recent Gallery */}
          {checkComponentActive("recent_gallery") && (
            <OurGallery dataSource={componentContent("recent_gallery")} />
          )}
          {/* Infrastructure */}
          {checkComponentActive("home_infrastructure") && (
            <HomeAboutUsPage
              dataSource={componentContent("home_infrastructure")}
            />
          )}

          {/* Website Links */}
          {/* {checkComponentActive("home_website_links") && (
            <HomeAboutUsPage
              dataSource={componentContent("home_website_links")}
            />
          )} */}

          {/* Home Page Content */}
          {checkComponentActive("home_page_content") && (
            <HomeAboutUsPage
              dataSource={componentContent("home_page_content")}
            />
          )}
          {/* Welcome Banner */}
          <WelcomeBanner />
        </>
      )}
    </div>
  );
};

export default HomePage;
